

export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export const nonNumericRegex = /^[A-Za-z\s]+$/;

export const sidebarData = [
  {
        id: 1,
        title: "Dashboard",
        link: "/administration/dashboard",
        icon: "ti ti-home",
        subMenu: [],
      },
  {
        id: 2,
        title: "Customer",
        
        icon: "ti ti-user",
        subMenu: [
          {
            id: 1,
            title: "Customer List",
            link: "/administration/customer",
            subMenu: [],
          },
          {
            id: 2,
            title: "Pending Approval Customer ",
            link: "/administration/pending-customer",
            subMenu: [],
          },
          
        ],
      },
  {
        id: 3,
        title: "Themes",
        link: "/administration/theme",
        icon: "ti ti-palette",
        subMenu: [
        ],
      },
  {
        id: 4,
        title: "Messages",
        icon: "ti ti-message-circle",
        subMenu: [
        ],
      },

  {
        id: 5,
        title: "Other Settings",
        link: "",
        icon: "ti ti-settings",
        subMenu: [
          {
            id: 1,
            title: "Testimonials",
            link: "/administration/testimonials",
            subMenu: [],
          },
          {
            id: 2,
            title: "Coupons",
            link: "/administration/coupons",
            subMenu: [],
          },
        

        ],
  },
  // {
  //       id: 6,
  //       title: "Contact Us",
  //       link: "/administration/contact-us",
  //       icon: "ti ti-message-circle",
  //       subMenu: [],
  //     },

];


export const LevelArr = [
  {label : "beginning", value : "beginning"},
  {label : "Intermediate", value : "Intermediate"},
  {label : "Advance", value : "Advance"},
  {label : "All level", value : "All level"},
]



